(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pack-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (root.__drPackInit) return;
      root.__drPackInit = true;

      var productId = root.getAttribute('data-product-id');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.dr-pack__tab'));
      if (!tabs.length) return;

      var priceNow = root.querySelector('[data-role="price-now"]');
      var priceWas = root.querySelector('[data-role="price-was"]');
      var finePrint = root.querySelector('[data-role="fine-print"]');
      var currentTab = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || tabs[0];
      var singleTab = tabs.filter(function (t) { return t.getAttribute('data-qty') === '1'; })[0];
      var baseUnitPrice = singleTab ? singleTab.getAttribute('data-unit-price') : null;

      function findVariantPicker() {
        var pickers = Array.prototype.slice.call(document.querySelectorAll('variant-picker'));
        for (var i = 0; i < pickers.length; i++) {
          if (pickers[i].dataset.productId === productId) return pickers[i];
        }
        return pickers[0] || null;
      }

      function markPage() {
        var scope = root.closest('[id^="shopify-section"]') || root.closest('.product-details') || document.body;
        scope.classList.add('dr-pack-hide-native-picker');
      }
      markPage();

      function setSubscriptionOneTime() {
        try {
          var groups = Array.prototype.slice.call(document.querySelectorAll('[class*="subscription_group"]'));
          groups.forEach(function (g) {
            var t = (g.textContent || '').toLowerCase();
            if (t.indexOf('subscribe') !== -1) {
              g.style.display = 'none';
            } else if (t.indexOf('one-time') !== -1 || t.indexOf('one time') !== -1) {
              g.style.display = '';
              var radio = g.querySelector('input[type="radio"]');
              if (radio && !radio.checked) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
                radio.dispatchEvent(new Event('input', { bubbles: true }));
              }
            }
          });
        } catch (e) {}
      }

      function restoreSubscriptionOptions() {
        try {
          var groups = Array.prototype.slice.call(document.querySelectorAll('[class*="subscription_group"]'));
          groups.forEach(function (g) { g.style.removeProperty('display'); });
        } catch (e) {}
      }

      function updateStickyBarPrice(tab) {
        try {
          var bar = document.querySelector('.sticky-add-to-cart__price');
          if (!bar) return;
          var unit = tab.getAttribute('data-unit-price');
          var priceEl = bar.querySelector('.price') || bar;
          priceEl.textContent = unit;
        } catch (e) {}
      }

      function setActiveTab(variantId) {
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-variant-id') === String(variantId));
        });
      }

      function applyTabDisplay(tab) {
        currentTab = tab;
        var qty = parseInt(tab.getAttribute('data-qty'), 10) || 1;
        var unit = tab.getAttribute('data-unit-price');
        var total = tab.getAttribute('data-total-price');
        if (priceNow) priceNow.textContent = unit;
        if (priceWas) {
          if (qty > 1) {
            priceWas.textContent = baseUnitPrice || "";
            priceWas.hidden = false;
          } else {
            priceWas.hidden = true;
          }
        }
        if (finePrint) {
          finePrint.textContent = qty > 1
            ? (qty + ' pouches at ' + unit + ' each. ' + total + ' total')
            : ('Charged as 1 pouch at ' + total);
        }
        if (qty > 1) setSubscriptionOneTime();
        else restoreSubscriptionOptions();

        updateStickyBarPrice(tab);
      }

      function selectTab(tab, opts) {
        opts = opts || {};
        // A real click wins. Give it a grace period so the poller below
        // cannot read a stale native picker state and snap the tab back.
        if (!opts.silent) suppressSyncUntil = Date.now() + 1500;
        var variantId = tab.getAttribute('data-variant-id');
        setActiveTab(variantId);
        applyTabDisplay(tab);

        if (opts.silent) return;

        var picker = findVariantPicker();
        if (!picker) return;
        var radio = picker.querySelector('input[data-variant-id="' + variantId + '"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { selectTab(tab); });
      });

      // Sync subscription visibility / sticky-bar price to the
      // server-rendered default selection on load (don't wait for a click).
      if (currentTab) applyTabDisplay(currentTab);

      // Self-heal: if the underlying variant picker's selection changes for
      // any other reason (browser back/forward, morph re-render, etc.),
      // keep the tab UI and price display in sync without fighting it. Also
      // re-assert the sticky bar's price on every tick, since the theme's
      // own sticky-bar script can re-render it and clobber our override.
      var lastKnownVariantId = null;
            var suppressSyncUntil = 0;
            var lastStickyValue = null;
            // Slower, and it no longer rewrites things that have not changed.
            // The old 250ms version fought the native picker on every click, which
            // is what made the buttons feel glitchy.
            setInterval(function () {
              if (Date.now() < suppressSyncUntil) return;
              var picker = findVariantPicker();
              if (picker) {
                var checked = picker.querySelector('input[type="radio"]:checked');
                if (checked) {
                  var variantId = checked.getAttribute("data-variant-id");
                  if (variantId && variantId !== lastKnownVariantId) {
                    lastKnownVariantId = variantId;
                    var t = tabs.filter(function (x) { return x.getAttribute("data-variant-id") === variantId; })[0];
                    if (t && !t.classList.contains("is-active")) selectTab(t, { silent: true });
                  }
                }
              }
              if (currentTab) {
                var u = currentTab.getAttribute("data-unit-price");
                if (u !== lastStickyValue) { lastStickyValue = u; updateStickyBarPrice(currentTab); }
        }
        if (currentTab && priceWas) {
          // Safety net. If a re-render blanks or wrongly hides the struck
          // price, put it back rather than leaving a broken looking page.
          var q2 = parseInt(currentTab.getAttribute("data-qty"), 10) || 1;
          var shouldShow = q2 > 1;
          var isShowing = !priceWas.hidden && (priceWas.textContent || "").length > 0;
          if (shouldShow !== isShowing) applyTabDisplay(currentTab);
              }
            }, 1000);
    }

    function initAll() {
      document.querySelectorAll('.dr-pack').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init if new instances get added (e.g. quick-view / ajax nav).
    new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
